import { render, staticRenderFns } from "./ConsultaView.vue?vue&type=template&id=45dd8a66&scoped=true"
import script from "./ConsultaView.vue?vue&type=script&lang=js"
export * from "./ConsultaView.vue?vue&type=script&lang=js"
import style0 from "./ConsultaView.vue?vue&type=style&index=0&id=45dd8a66&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dd8a66",
  null
  
)

export default component.exports